import { Component, OnInit } from '@angular/core';
import { OutlookLoginService } from '../../services';

@Component({
    selector: 'callback',
    template: `
    <div class="splash">
        <div class="splash-text">
            <span class="jms"><img src="/images/WorkBuddy.svg" /></span>
        </div>
    </div>
    `,
    standalone: false
})
export class CallbackComponent implements OnInit {
    constructor(private outlookLogin: OutlookLoginService) { }

    ngOnInit() {
        this.outlookLogin.callBackAfterLogin();
    }
}
